import { Timeout } from './timeout';
import { VerifyDevice } from './verify-device';

export const RiskyLogin = { Timeout, VerifyDevice };
